module.exports = __webpack_public_path__ + "img/drugs-pharmacy.6ff4e8d2.svg";